import { capitalize } from 'lodash';
import pluralize from 'pluralize';
import { Formatter } from '../../../../../hooks';
import { getCollaboratorLabel, WorkspaceContextV2 } from '../../../../app';
import { GroupItemAggregate } from './groupItemModel';
import { GroupItemViewProps } from './groupItemProps';

export function buildGroupItemViewProps(
    formatter: Formatter,
    context: WorkspaceContextV2,
    item: GroupItemAggregate,
    index: number
): GroupItemViewProps {
    const format = {
        date: {
            relative: formatter.timeago(item.group.createdAt, {}),
        },
    };
    const plural = {
        member: item.count.member ? pluralize('member', item.count.member.value) : null,
    };
    return {
        id: item.group.id,
        label: item.group.name,
        creator: {
            label: item.user ? getCollaboratorLabel(item.user) : 'N/A',
        },
        privacy: {
            label:
                item.group.privacy.length === 0
                    ? 'No privacy'
                    : item.group.privacy.map((item) => capitalize(item)).join(', '),
        },
        role:
            index === 0
                ? {
                      kind: 'owner',
                      label: 'Owner',
                      description: `Voluptate exercitation mollit est ea est incididunt excepteur cillum cillum mollit occaecat eu ipsum`,
                  }
                : {
                      kind: 'member',
                      label: 'Member',
                      description: `Ut consequat consectetur adipisicing deserunt sit aliqua aliquip tempor`,
                  },
        created: {
            relative: {
                label: format.date.relative,
            },
        },
        count: {
            member:
                item.count.member && plural.member
                    ? {
                          label: `${item.count.member.value} ${plural.member}`,
                      }
                    : { label: 'No members' },
        },
        links: {
            detail: {
                to: item.group.id,
            },
        },
    };
}
